import { AppState } from "../rootReducer";

export const getSearchText = (state: AppState) => state.search.searchText || "";

export const getSearchType = (state: AppState) =>
  state.search.searchType || "message-user";
